export default __webpack_public_path__ + "static/media/web-banner.a5b330ea.png";